var map = {
	"./decidim/avatar-multiuser.png": 58992,
	"./decidim/brands/facebook.svg": 32206,
	"./decidim/brands/google.svg": 1519,
	"./decidim/brands/twitter-x.svg": 21092,
	"./decidim/cc-badge.png": 94522,
	"./decidim/decidim-logo.svg": 22930,
	"./decidim/default-avatar.svg": 98670,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 1874,
	"./decidim/icons.svg": 29969,
	"./decidim/pattern.png": 81214,
	"./decidim/placeholder-card-g.svg": 16851,
	"./decidim/placeholder-card-l.svg": 36248,
	"./decidim/placeholder.jpg": 15439,
	"./decidim/remixicon.symbol.svg": 89335,
	"./decidim/vendor/social-share-button/douban.svg": 10790,
	"./decidim/vendor/social-share-button/email.svg": 71491,
	"./decidim/vendor/social-share-button/facebook.svg": 42293,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 37327,
	"./decidim/vendor/social-share-button/hacker_news.svg": 81559,
	"./decidim/vendor/social-share-button/linkedin.svg": 39883,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 34452,
	"./decidim/vendor/social-share-button/pinterest.svg": 41029,
	"./decidim/vendor/social-share-button/reddit.svg": 47381,
	"./decidim/vendor/social-share-button/telegram.svg": 78860,
	"./decidim/vendor/social-share-button/tumblr.svg": 86067,
	"./decidim/vendor/social-share-button/twitter.svg": 25858,
	"./decidim/vendor/social-share-button/vkontakte.svg": 96252,
	"./decidim/vendor/social-share-button/wechat.svg": 24663,
	"./decidim/vendor/social-share-button/whatsapp.svg": 6583,
	"./decidim/vendor/social-share-button/x.svg": 36835,
	"./decidim/vendor/social-share-button/xing.svg": 64101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98821;